export * from './CustomHamperDesktopSlot';
export * from './CustomHamperMobileSlot';
